<template>
    <div>{{ helptext }}</div>
</template>
<script>
    import { NAMESPACE, KEYS } from "./i18n/formSenseHelptext.i18n";
    import { mapI18n } from "Util/i18n";

    export default {
        computed: {
            ...mapI18n(
                {
                    ...KEYS
                },
                NAMESPACE
            )
        }
    };
</script>
